import { Injectable } from '@angular/core';
import { SearchService } from '../../../../shared/search/search.service';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { SearchStatus } from '../../../../shared/search/models/search-status.model';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { DetailedEntityDataService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { SearchableEntityConfig } from '../../../../shared/models/searchable-entity-config';
import { InventoryReplenishDataEditorService } from './inventory-replenish-data-editor.service';
import { InventoryReplenishKeyEventHandlerService } from './inventory-replenish-detail-view-key-event-handler.service';
import { InventoryReplenishSearchService } from './inventory-replenish-search.service';

@Injectable()
export class InventoryReplenishDataService extends DetailedEntityDataService {

    public searchService: SearchService;
    public searchParams: SearchParams;
    public searchStatus: SearchStatus;
    public entityConfig: SearchableEntityConfig;
    private itemLabel: string;
    // This is used to store the details fetched by the initial api upon page call.These values are used for
    // displaying  the various dropdwons and testing variables
    public inventoryReplenishMap: Array<any>;
    public groupDropdownValues: Array<any> = [{key: 'All', value: 'All'}];
    public strategyDropDownValues: Array<any> = [{key: '', value: 'Select'}];
    public reportTypeDropdownvalues: Array<any>;
    public showTableforInv: boolean = false;
    public lotLineMap: any;
    public tabbedSearchServices: Array<SearchService> = [];


    // The roletype dropdown in detail role is hardcoded
    public typeDropdownOptions: Array<any> = [{ key: 'Condition', value: 'CONDITION' },
    { key: 'Required', value: 'REQUIRED' },
    { key: 'StoredProcedure', value: 'STOREDPROC' },
    { key: 'Contains', value: 'CONTAINS' }];

    public facilitydropdownvalues: Array<any>;
    // this isfor the colNmae field in Detail Role
    public colNameDropdownOptions: Array<any>;
    public dataEditorService: InventoryReplenishDataEditorService;
    public keyEvenetHandler: InventoryReplenishKeyEventHandlerService

        = new InventoryReplenishKeyEventHandlerService(this.dataEditorService);

    public getItemLabel() {
        return this.itemLabel;
    }

    public setItemLabel(itemLabel) {
        return this.itemLabel = itemLabel;
    }

    public getTabDetailsSearchService() {
        return this.tabbedSearchServices[0];
    }

    public getTabPostSearchService() {
        return this.tabbedSearchServices[1];
    }
    public initializeDetailsSearchContext() {
        this.detailsSearchParams = this.entityConfig.getDetailSearchParams();
        this.detailsSearchParams.defaultSearchColumn = '';
        this.detailsSearchParams.tableEditor = this.dataEditor;
        this.detailsSearchParams.alertService = this.alertService;
        if (this.buttonService) {
            this.detailsSearchParams.actionButtons = this.buttonService.getButtonsForPanel('detail-table');
        }
        this.detailsSearchStatus = new SearchStatus();
        //    this.originalSearchService = this.sharedServiceRegistry.createSearchService(this.detailsSearchParams,
        //        this.detailsSearchStatus);

        const transferSearchService: InventoryReplenishSearchService = new InventoryReplenishSearchService(this.coreServiceRegistry, this.sharedServiceRegistry,
            this.detailsSearchParams, this.detailsSearchStatus);
        transferSearchService.setDataService(this);
        this.detailsSearchService = transferSearchService;

    }



}





// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/inventory-replenish/services/inventory-replenish-data.service.ts